export const urlify = (text: string) => {
	const urlRegex =/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
	return text.replace(urlRegex, (url: string) => {
		return '<a href="' + url + '" target="_blank">' + url + '</a>'
	})
}